import { render, staticRenderFns } from "./ServerComponent.vue?vue&type=template&id=43da1bbb&scoped=true&"
import script from "./ServerComponent.vue?vue&type=script&lang=js&"
export * from "./ServerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServerComponent.vue?vue&type=style&index=0&id=43da1bbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da1bbb",
  null
  
)

component.options.__file = "ServerComponent.vue"
export default component.exports